<span *ngIf="status">({{ status | uppercase }})</span>
